import tw from 'twin.macro';

const Content = tw.p`flex font-body text-xs text-base whitespace-pre-wrap max-w-lg`;

export default Content;
